<template>
  <div class="w-[1200px]">
    <div class="grid search-result">
      <CardItem
        v-for="(item, index) in calList"
        :key="index"
        :data="item"
        @click="onHandleClick(item)"
        @change="onChange($event, item)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import CardItem from '~/features/template/components/cardItem.vue'
import type { Template } from '~/api/interface/template'
import { getTagIDs } from '~/features/template'
import { useTemplateDetail } from '~/hooks/useModal/modals/template'
import { useStarPatchList } from '~/hooks/useStarPatch'

const props = defineProps<{
  max?: number
  data: Template[]
}>()

const resourceLocation = injectResourceLocation()
const userInfo = useUserInfo()

const newResult = computed(() => {
  if (props.max) {
    const target = [...props.data].slice(0, props?.max)
    const vertical = target.filter((item) => item.resolution === '1080x1920')
    return target
      .sort((a, b) => {
        return a.resolution === '1080x1920' ? -1 : 1
      })
      .slice(0, props.max && props?.max - vertical.length)
  }
  return props.data
})

const onChange = ([key, value]: [string, any], data: Template) => {
  const item: any = newResult.value.find((item) => {
    return item.id === data.id
  })
  if (item) {
    item[key] = value
  }
}

const { calList } = useStarPatchList(newResult, 3)

const onHandleClick = (data: Template) => {
  const trackParams = {
    template_id: data.id,
    template_title: data.name,
    source: resourceLocation?.source,
    tags: getTagIDs(data.tag_ids).map((item) => item.tag_name),
    org_id: userInfo.value?.organization_id,
  }

  trackEvent(TRACK_EVENT.CLICK_SEARCH_WORK, trackParams)

  useTemplateDetail(
    newResult.value,
    data,
    {
      templateSource: TEMPLATE_SOURCE.SEARCH,
      source: resourceLocation?.source,
    },
    onChange
  )
}
</script>

<style lang="scss" scoped>
.search-result {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-auto-flow: dense;
  grid-auto-rows: 230px;
  gap: 12px;
}
:deep(.card-item.vertical) {
  grid-row: span 2;
}
</style>
